<div class="content">
    <div class="div">
        <div class="title">{{ title }}</div>
        <div class="subtitle" *ngIf="subtitle">{{ subtitle }}</div>
    </div>

    <div class="divider"></div>
</div>